<script lang="ts">
    import Shortcodes from "./Shortcodes.svelte"
    import Placeholder from "./Module/Placeholder.svelte"

    export let row: PagebuilderRow
    export let idx: number = 1
    export let sprungpunkte: { idx: number; titel: string }[] = null
    export let scrollToElement: Function = (_options) => {}
    export let imgBasePath: string
    export let _i18n: Function = (s) => s
    export let Module = { placeholder: Placeholder }
    export let shortcodeComponents = {}
</script>

{#if row.aktiv}
    <div class="pagebuilder-section sprung{idx}">
        {#if row.titel}
            <h3>{row.titel}</h3>
        {/if}

        <div class="row {row.vertikaleAusrichtung}">
            {#if sprungpunkte?.length && idx == 0}
                <div class="col order-2 order-md-1 ql-editor">
                    <Shortcodes
                        components="{shortcodeComponents}"
                        html="{row.spalten?.spalte1?.html}"
                    />
                    {#if row.spalten?.spalte1?.modul}
                        {#if Module[row.spalten?.spalte1?.modul]}
                            <svelte:component
                                this="{Module[row.spalten.spalte1.modul]}"
                            />
                        {:else}
                            <Placeholder text="{row.spalten.spalte1.modul}" />
                        {/if}
                    {/if}
                </div>
                <div class="col order-1 order-md-2">
                    <div class="content_table">
                        <h2>{_i18n("Themen")}</h2>
                        <ul>
                            {#each sprungpunkte as s}
                                <li>
                                    <a
                                        href="#sprung{s.idx}"
                                        on:click|preventDefault="{() => {
                                            scrollToElement({
                                                element: '.sprung' + s.idx,
                                                offset: -150,
                                            })
                                        }}"
                                        ><span class="icon"
                                            ><img
                                                src="/media/chevrons-right.svg"
                                                alt=""
                                            /></span
                                        >{s.titel}</a
                                    >
                                </li>
                            {/each}
                        </ul>
                    </div>
                </div>
            {:else}
                {#each [row.spalten?.spalte1, row.spalten?.spalte2, row.spalten?.spalte3] as spalte}
                    {#if spalte?.bild || spalte?.html || spalte?.modul}
                        <div class="col ql-editor {spalte.breite}">
                            {#if spalte.bild}
                                {#if spalte.bildHref}
                                    <a
                                        class="imglink"
                                        href="{spalte.bildHref}"
                                        target="{(spalte.bildTargetBlank &&
                                            'blank') ||
                                            undefined}"
                                    >
                                        <img
                                            src="{!spalte.bild?.src?.startsWith(
                                                'data:'
                                            )
                                                ? imgBasePath +
                                                  '/' +
                                                  spalte.bild?.src +
                                                  '?filter=l'
                                                : spalte.bild?.src}"
                                            alt="{row.titel}"
                                        />
                                    </a>
                                {:else}
                                    <img
                                        src="{!spalte.bild?.src?.startsWith(
                                            'data:'
                                        )
                                            ? imgBasePath +
                                              '/' +
                                              spalte.bild?.src +
                                              '?filter=l'
                                            : spalte.bild?.src}"
                                        alt="{row.titel}"
                                    />
                                {/if}
                                {#if spalte.html}
                                    <div class="imgtext">
                                        <Shortcodes
                                            components="{shortcodeComponents}"
                                            html="{spalte.html}"
                                        />
                                    </div>
                                {/if}
                            {:else}
                                <Shortcodes
                                    components="{shortcodeComponents}"
                                    html="{spalte.html}"
                                />
                            {/if}

                            {#if spalte.modul}
                                {#if Module[spalte.modul]}
                                    <svelte:component
                                        this="{Module[spalte.modul]}"
                                    />
                                {:else}
                                    <Placeholder text="{spalte.modul}" />
                                {/if}
                            {/if}
                        </div>
                    {/if}
                {/each}
            {/if}
        </div>
    </div>
{/if}

<style lang="less">
    @import "../css/base.less";

    .pagebuilder-section :global {
        h4 {
            margin-top: 0px;
            margin-bottom: 3px;
        }
        p:last-child {
            margin-bottom: 0px;
        }
    }

    .content_table {
        background: #fff;
        box-shadow: 0 0 40px 0 rgba(51, 51, 51, 0.2);
        padding: 25px;
        max-width: 580px;
        height: auto;
        width: 100%;
        margin-bottom: 15px;
        h2 {
            font-weight: 400;
            font-size: 1.5rem;
            margin-top: 0px;
            @media (max-width: 768px) {
                font-size: 1.2rem;
            }
            &:before {
                display: none;
            }
        }
        ul {
            list-style-type: none;
            margin: 15px 0px;
            padding: 0px;
            li {
                margin-bottom: 7px;
                a {
                    .flex();
                    align-items: flex-start;
                    .icon {
                        padding-top: 3px;
                        width: 20px;
                        height: 20px;
                        margin-right: 10px;
                        img {
                            width: 20px;
                            height: auto;
                        }
                    }
                    font-style: italic;
                }
            }
        }
    }
</style>
